import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    //src: 'https://localhost:44320',
    //subDirectory: ''
    //src: '',
    //subDirectory: '/Platform'
    src: 'https://international.ntua.edu.tw',
    subDirectory: '/Platform'
    //src: 'https://international.thinker.tw',
    //subDirectory: '/Platform'
  },
  getters: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
  }
})
